
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    LinearScale,
    Tooltip
} from 'chart.js';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useMutation } from 'react-query';
import Card from '../../../components/Card';
import { TotalVisitsRes } from '../../../models';
import { httpGET } from '../../../utils/ajaxHelper';
import { StateDashBoardProviderContext } from '../stateDashBoardProvider';
import { ITotalVisitsProps } from './totalVisits.props';
import { Container } from './totalVisits.styled';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
);

export const TotalVisits = ({ comOfferingType, orgFilter, isAllowMobile }: ITotalVisitsProps) => {
    // const [type, setType] = useState<"this_year" | "last_year">("this_year");
    const StateDashBoard = useContext(StateDashBoardProviderContext);
    const backgroundColor = process.env.REACT_APP_COLOR_OF_THE_CHART?.split(",");
    const monthNames: string[] = [];
    for (let i = 0; i < 12; i++) {
        const monthName = moment().month(i).format('MMM');
        monthNames.push(monthName);
    }

    const [totalVisits, setTotalVisits] = useState<TotalVisitsRes[]>();
    const { mutate: totalVisitsFetch } = useMutation(
        (type: string) =>
            httpGET({
                url: "/DashboardReport/total-visits",
                params: {
                    timeZone: new Date().getTimezoneOffset() / (-60),
                    interval: type,
                    offeringType: comOfferingType?.value,
                    orgId: orgFilter?.value
                }
            }),
        {
            onSuccess: (rs) => {
                setTotalVisits(rs);
            },
        },
    );
    useEffect(() => {
        totalVisitsFetch(StateDashBoard!.typeVisit)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comOfferingType, orgFilter])

    useEffect(() => { totalVisitsFetch(StateDashBoard!.typeVisit) }, [StateDashBoard!.typeVisit]);
    if (!totalVisits) { return null; }
    const results = monthNames.map(e => {
        return {
            monthName: e,
            count: totalVisits.find(f => f.month === e)?.count
        };
    });

    return (
        <Card className='h-full'>
            <Container>
                <h2 className='mb-[16px]'>
                    Total Visits
                    <div className="line" />
                    <div className="option" onClick={() => { StateDashBoard!.setTypeVisit("this_year") }}>
                        <Dot color={StateDashBoard!.typeVisit === "this_year" ? "#333333" : "#A8C5DA"} />
                        <span className={!isAllowMobile ? "mb-[16px]" : ""}>
                            This year
                        </span>
                    </div>
                    <div className="option" onClick={() => { StateDashBoard!.setTypeVisit("last_year") }}>
                        <Dot color={StateDashBoard!.typeVisit === "last_year" ? "#333333" : "#A8C5DA"} />
                        <span className={!isAllowMobile ? "mb-[16px]" : ""}>
                            Last year
                        </span>
                    </div>
                    <div className="year">
                        {StateDashBoard!.typeVisit === "this_year" ? moment().year() : moment().add(-1, 'y').year()}
                    </div>
                </h2>
                {totalVisits.length > 0 ? (
                    <div
                        className="h-full flex-1 flex flex-row"
                    >
                        <div className='h-auto w-[32px]'>
                            <Bar
                                options={{
                                    layout: {
                                        padding: {
                                            bottom: 39,
                                        }
                                    },
                                    scales: {
                                        x: {
                                            grid: {
                                                display: false,
                                                drawTicks: false,
                                            },
                                            ticks: {
                                                display: false,
                                            },
                                        },
                                        y: {
                                            grid: {
                                                display: false,
                                            },
                                            beginAtZero: true,
                                            afterFit: (ctx) => {
                                                ctx.width = 35;
                                            }
                                        },
                                    },
                                    maintainAspectRatio: false,
                                }}
                                data={{
                                    labels: results?.map(e => e.monthName),
                                    datasets: [
                                        {
                                            data: results?.map(e => e.count),
                                        }
                                    ],
                                }}
                            />
                        </div>

                        <div className='h-auto overflow-auto no-scrollbar-disable flex-1'>
                            <div className='min-w-[650px] h-full min-h-inherit w-full'>
                                <Bar
                                    options={{
                                        scales: {
                                            x: {
                                                grid: {
                                                    display: false,
                                                },
                                            },
                                            y: {
                                                beginAtZero: true,
                                                grid: {
                                                    display: false,
                                                },
                                                ticks: {
                                                    display: false,
                                                },
                                            },
                                        },
                                        maintainAspectRatio: false,
                                        layout: {
                                            padding: {
                                                top: 10,
                                                bottom: 10,
                                            }
                                        },
                                    }}
                                    data={{
                                        labels: results?.map(e => e.monthName),
                                        datasets: [
                                            {
                                                data: results?.map(e => e.count),
                                                backgroundColor: backgroundColor,
                                                borderRadius: 8,
                                                borderSkipped: false,
                                                barThickness: 28,
                                            }
                                        ],
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                ) : (<div className="no-result">
                    No results found.
                </div>)}
            </Container>
        </Card>
    );
}


const Dot = ({ color }: any) => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z"
            fill={color}
        />
    </svg>
}